import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Stepper } from "states/global-value/global-value.models";
interface StepProps {
  step: Stepper;
}
export const StepperComponent = (props: StepProps) => {
  const { step } = props;
  const stepper = () => {
    switch (step) {
      case Stepper.Address:
        return (
          <div className="step-container">
            <div className="col-lg-4 col-md-4 col-xs-4 col-sm-4 bs-wizard-step complete">
              <div className="text-center bs-wizard-stepnum">
                <span>Giỏ hàng</span>
              </div>
              <div className="progress">
                <div className="progress-bar" />
              </div>
              <span className="bs-wizard-dot">
                <Link to="/cart">
                <span className="ecs-ok"></span>
                </Link>
              </span>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-4 col-sm-4 bs-wizard-step active">
              <div className="text-center bs-wizard-stepnum">
                <span>Địa chỉ</span>
              </div>
              <div className="progress">
                <div className="progress-bar" />
              </div>
              <span className="bs-wizard-dot">1</span>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-4 col-sm-4 bs-wizard-step disabled">
              <div className="text-center bs-wizard-stepnum">
                <span>Đặt hàng</span>
              </div>
              <div className="progress">
                <div className="progress-bar" />
              </div>
              <span className="bs-wizard-dot">2</span>
            </div>
          </div>
        );
      case Stepper.Checkout:
        return (
          <div className="step-container">
             <div className="col-lg-4 col-md-4 col-xs-4 col-sm-4 bs-wizard-step complete">
              <div className="text-center bs-wizard-stepnum">
                <span>Giỏ hàng</span>
              </div>
              <div className="progress">
                <div className="progress-bar" />
              </div>
              <span className="bs-wizard-dot">
                <span className="ecs-ok"></span>
              </span>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-4 col-sm-4 bs-wizard-step complete">
              <div className="text-center bs-wizard-stepnum">
                <span>Địa chỉ</span>
              </div>
              <div className="progress">
                <div className="progress-bar" />
              </div>
              <span className="bs-wizard-dot">
                <Link to="/cart/address">
                  <span className="ecs-ok"></span>
                </Link>
              </span>
            </div>
            <div className="col-lg-4 col-md-4 col-xs-4 col-sm-4 bs-wizard-step active">
              <div className="text-center bs-wizard-stepnum">
                <span>Đặt hàng</span>
              </div>
              <div className="progress">
                <div className="progress-bar" />
              </div>
              <span className="bs-wizard-dot">2</span>
            </div>
          </div>
        );
    }
    return <React.Fragment />;
  };
  return stepper();
};
